import React, { useEffect, useEffectEvent, useState } from "react";
import LogoCEA from "../assets/images/logo.png";
import "../style/registermonthly.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import SyncLoader from "react-spinners/SyncLoader";
import DateInput from "./DateInput";

const RegisterMonthly = ({ classDetails = [], requiresApproval = false }) => {
  const [studentId, setStudentId] = useState("");
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [confirmEmail, setConfirmEmail] = useState("");
  const [emailVerify, setEmailVerify] = useState("");
  const [phone, setPhone] = useState("");
  const [dob, setDob] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [province, setProvince] = useState("");
  const [postal, setPostal] = useState("");
  const [sp, setSp] = useState("");
  const [church, setChurch] = useState("");
  const [otherChurch, setOtherChurch] = useState("");
  const [classType, setClassType] = useState("");
  const [dj, setDj] = useState("");
  const [role, setRole] = useState("");
  const [programs, setPrograms] = useState("1 Month Course");
  const [classes, setClasses] = useState({
    className: [],
  });
  // "full" = bayar semua kelas sekaligus, "installment" = ditagih per kelas
  // saat bulan kelas itu tiba (hanya ditawarkan kalau ambil >1 kelas).
  // Sengaja TANPA default: student harus memilih sendiri cara bayarnya, supaya
  // tidak ada yang ter-submit "full" hanya karena pertanyaannya terlewat dibaca.
  const [paymentPlan, setPaymentPlan] = useState("");
  const [tshirtSize, setTshirtSize] = useState("");
  const [joined, setJoined] = useState("");
  const [year, setYear] = useState("");
  const [q1, setQ1] = useState("");
  const [q2, setQ2] = useState("");
  const [q3, setQ3] = useState("");
  const [q4, setQ4] = useState("");
  const [q5, setQ5] = useState("");
  const [next, setNext] = useState(false);
  const [data, setData] = useState([]);
  const [currentClass, setCurrentClass] = useState("");

  const classOrder = [
    "OT",
    "NT",
    "BD",
    "BLC",
    "BCMF",
    "HH",
    "CBH",
    "CBD",
    "BWG",
    "MMM",
  ];

  const [isLoading, setIsLoading] = useState(false);

  // Kelas yang benar-benar ditagih kali ini — kelas "completed" (sudah pernah
  // lunas untuk student returning) tidak dihitung. Pilihan Payment Option hanya
  // muncul (dan hanya wajib diisi) kalau jumlahnya lebih dari satu.
  const billableClassCount = classes.className.filter(
    (cl) => cl.status !== "completed",
  ).length;
  const needsPaymentPlan = billableClassCount > 1;

  useEffect(() => {
    axios.get("/config/currentclass")
      .then((res) => { if (res.data.currentClass) setCurrentClass(res.data.currentClass); })
      .catch(() => {});
  }, []);

  const navigate = useNavigate();

  const handleNavigate = (goto) => {
    navigate(goto);
  };

  const handleCheckboxChange = (value) => {
    setClasses((prev) => {
      const exists = prev.className.find((c) => c.name === value);

      let updated;

      if (exists) {
        // jika status completed → tidak boleh dihapus
        if (exists.status === "completed") {
          return prev;
        }

        // jika requested → boleh dihapus
        updated = prev.className.filter((c) => c.name !== value);
      } else {
        // tambahkan kelas baru dengan status requested
        updated = [...prev.className, { name: value, status: "requested" }];
      }

      // sorting sesuai urutan kelas
      updated.sort(
        (a, b) => classOrder.indexOf(a.name) - classOrder.indexOf(b.name),
      );

      return {
        // ...prev,
        className: updated,
      };
    });
    // console.log(classes);
  };

  const handleSubmit = async (e, emailAddress) => {
    e.preventDefault();
    if (
      fullName === "" ||
      email === "" ||
      phone === "" ||
      dob === "" ||
      address === "" ||
      city === "" ||
      province === "" ||
      postal === "" ||
      sp === "" ||
      (church === "Others" ? otherChurch === "" : dj === "" || role === "") ||
      (church !== "Others" && (dj === "" || role === "")) ||
      church === "" ||
      classType === "" ||
      programs === "" ||
      classes.className.length === 0 ||
      (needsPaymentPlan && paymentPlan === "") ||
      joined === "" ||
      q1 === "" ||
      q2 === "" ||
      q3 === "" ||
      q4 === "" ||
      q5 === ""
    ) {
      handleSubmitError();
      return;
    }

    // Cegah salah ketik email untuk pendaftar BARU (joined "No"): email &
    // konfirmasinya harus sama. Pendaftar lama (joined "Yes") emailnya diambil
    // dari lookup record, jadi tidak perlu konfirmasi.
    if (joined === "No" && email.trim().toLowerCase() !== confirmEmail.trim().toLowerCase()) {
      await Swal.fire({
        text: "Email and Confirm Email do not match. Please re-check your email address.",
        icon: "error",
      });
      return;
    }

    const result = await Swal.fire({
      text: "Are you sure want to submit this data?",
      icon: "question",
      background: "white",
      color: "black",
      backdrop: `rgba(131, 131, 131, 0.5)`,
      showCancelButton: true,
      confirmButtonColor: "#0004ff",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      customClass: {
        confirmButton: "custom-btn-sweetalrt",
      },
    });
    if (result.isConfirmed) {
      setIsLoading(true);
      try {
        const payload = {
          studentId: studentId,
          name: fullName,
          email: email,
          phoneNumber: phone,
          dateOfBirth: dob,
          address: address,
          city: city,
          province: province,
          postalCode: postal,
          studentPackage: sp,
          localChurch: church === "Others" ? otherChurch : church,
          lastDj: dj,
          role: role,
          classType: classType,
          programs: programs,
          tshirtSize: "",
          classes: classes,
          currentClass: currentClass,
          // Cicilan per kelas hanya berlaku kalau ambil lebih dari 1 kelas BARU —
          // syarat yang sama persis dengan munculnya pilihan Payment Option di
          // form, jadi kalau pilihannya tidak ditampilkan tetap terkirim "full".
          paymentPlan: needsPaymentPlan ? paymentPlan : "full",
          // Form khusus (/registermonthlyspecial): selalu masuk approval page
          // agar admin menetapkan diskon terlebih dahulu.
          forceReview: requiresApproval,
          joinedCEA: joined,
          // year: year,
          question1: q1,
          question2: q2,
          question3: q3,
          question4: q4,
          question5: q5,
        };

        let orderResponse;
        if (data.length === 0) {
          orderResponse = await axios.post("/approval", payload);
        } else {
          orderResponse = await axios.patch(
            `/student/${emailAddress}`,
            payload,
          );
        }

        setIsLoading(false);

        const confirmBtn = await Swal.fire({
          text: orderResponse.data.paymentRequired
            ? "Data submitted! Please check your email for the payment link to complete your registration."
            : "Data Submitted.",
          icon: "success",
          background: "white",
          color: "black",
          backdrop: `rgba(131, 131, 131, 0.5)`,
          confirmButtonColor: "#0004ff",
          confirmButtonText: "OK",
        });

        if (confirmBtn.isConfirmed) {
          navigate("/programs");
          window.location.reload();
        }
      } catch (error) {
        setIsLoading(false);
        Swal.fire({
          text: `${error.response.data.msg}`,
          icon: "error",
          background: "white",
          color: "black",
          backdrop: `rgba(131, 131, 131, 0.5)`,
          confirmButtonColor: "#0004ff",
          confirmButtonText: "OK",
        });
      }
    } else if (result.isDismissed) {
      setIsLoading(false);
    }
  };

  // const handleTest = (e) => {
  //   e.preventDefault();
  //   console.log(fullName);
  //   console.log(email);
  //   console.log(phone);
  //   console.log(dob);
  //   console.log(address);
  //   console.log(city);
  //   console.log(province);
  //   console.log(postal);
  //   console.log(sp);
  //   console.log(church);
  //   console.log(otherChurch);
  //   console.log(dj);
  //   console.log(role);
  //   console.log(classType);
  //   console.log(programs);
  //   console.log(classes);
  //   console.log(joined);
  //   console.log(year);
  //   console.log(q1);
  //   console.log(q2);
  //   console.log(q3);
  //   console.log(q4);
  //   console.log(q5);
  // };

  const handleSubmitError = async (e) => {
    await Swal.fire({
      text: "Please input all data!",
      icon: "error",
      background: "white",
      color: "black",
      backdrop: `rgba(131, 131, 131, 0.5)`,
      confirmButtonColor: "#0004ff",
      confirmButtonText: "OK",
      customClass: {
        confirmButton: "custom-btn-sweetalrt",
      },
    });
  };

  const handleNext = async (id) => {
    if (joined === "No") {
      setData([]);
      setStudentId("");
      setFullName("");
      setEmail("");
      setPhone("");
      setDob("");
      setAddress("");
      setCity("");
      setProvince("");
      setPostal("");
      setSp("");
      setChurch("");
      setOtherChurch("");
      setRole("");
      setDj("");
      setClassType("");
      setPrograms("1 Month Course");
      setClasses({
        className: [],
      });
      setTshirtSize("");
      // setJoined("");
      setYear("");
      setQ1("");
      setQ2("");
      setQ3("");
      setQ4("");
      setQ5("");
      setNext(!next);
    } else {
      if (emailVerify === "") {
        handleSubmitError();
        return;
      }
      const response = await axios.get(`/verifydata/${id}`);
      // console.log(response);
      if (response.data === null) {
        await Swal.fire({
          text: "You never registered CEA with this email, please fill form as a new student",
          icon: "error",
          background: "white",
          color: "black",
          backdrop: `rgba(131, 131, 131, 0.5)`,
          confirmButtonColor: "#0004ff",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "custom-btn-sweetalrt",
          },
        });
        setData([]);
        setStudentId("");
        setFullName("");
        setEmail("");
        setPhone("");
        setDob("");
        setAddress("");
        setCity("");
        setProvince("");
        setPostal("");
        setSp("");
        setChurch("");
        setOtherChurch("");
        setRole("");
        setDj("");
        setClassType("");
        setPrograms("1 Month Course");
        setClasses({
          className: [],
        });
        setTshirtSize("");
        // Email tidak ditemukan → student ini sebenarnya pendaftar BARU. Set
        // joined "No" supaya diperlakukan sebagai new student, termasuk memunculkan
        // field Confirm Email di form berikutnya.
        setJoined("No");
        setYear("");
        setQ1("");
        setQ2("");
        setQ3("");
        setQ4("");
        setQ5("");
        setNext(!next);
      } else if (response.data.program === "1 Year Program") {
        await Swal.fire({
          text: "This email is already registered as 1 Year Program Student, please use another email.",
          icon: "error",
          background: "white",
          color: "black",
          backdrop: `rgba(131, 131, 131, 0.5)`,
          confirmButtonColor: "#0004ff",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "custom-btn-sweetalrt",
          },
        });
      } else if (response.data.msg === "Your data still in approval process.") {
        await Swal.fire({
          text: response.data.msg,
          icon: "info",
          background: "white",
          color: "black",
          backdrop: `rgba(131, 131, 131, 0.5)`,
          confirmButtonColor: "#0004ff",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "custom-btn-sweetalrt",
          },
        });
      } else {
        setData(response.data);
        setStudentId(response.data.studentId);
        setFullName(response.data.name);
        setEmail(response.data.email);
        setPhone(response.data.phoneNumber);
        setDob(response.data.dateOfBirth);
        setAddress(response.data.address);
        setCity(response.data.city);
        setProvince(response.data.province);
        setPostal(response.data.postalCode);
        setSp(response.data.studentPackage);
        if (response.data.localChurch !== "IFGF Bandung") {
          setChurch("Others");
          setOtherChurch(response.data.localChurch);
        } else {
          setChurch(response.data.localChurch);
          setRole(response.data.role);
          setDj(response.data.lastDj);
        }
        setClassType(response.data.classType);
        setPrograms(response.data.program);
        setClasses(
          typeof response.data.classList === "string"
            ? JSON.parse(response.data.classList)
            : response.data.classList,
        );
        // console.log(response.data);
        setTshirtSize(response.data.tshirtSize);
        setJoined("Yes");
        setYear(response.data.yearJoined);
        setQ1(response.data.question1);
        setQ2(response.data.question2);
        setQ3(response.data.question3);
        setQ4(response.data.question4);
        setQ5(response.data.question5);
        // console.log(response.data);
        setNext(!next);
      }
    }
    // console.log(data);
  };

  // console.log(joined);

  const handleKeyDown = (e) => {
    if (e.key === "Tab") {
      e.preventDefault();
    }
  };

  useEffect(() => {
    const html = document.documentElement;

    if (next) {
      document.body.style.overflow = "";
      html.style.overflow = "";
    } else {
      document.body.style.overflow = "hidden";
      html.style.overflow = "hidden";
    }

    return () => {
      document.body.style.overflow = "";
      html.style.overflow = "";
    };
  }, [next]);

  return (
    <main className="position-relative" style={{ height: "100vh" }}>
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <SyncLoader color={"#fb3104"} size={12} />
          <p
            style={{
              color: "white",
              marginTop: "1.5rem",
              fontSize: "1em",
              fontWeight: "500",
            }}
          >
            Processing your registration...
          </p>
        </div>
      )}
      <div className="custom-con-nav-register position-relative top-0 start-50 translate-middle-x">
        <div className="custom-con-img-regisform position-absolute top-50 end-0 translate-middle-y">
          <img
            className="adjust-img-register object-fit-contain"
            src={LogoCEA}
            alt="logoCEA.png"
          />
        </div>
        <i
          className="custom-icon-arrow-register bi bi-arrow-left position-absolute top-50 start-0 translate-middle-y"
          onClick={
            next ? () => setNext(!next) : () => handleNavigate("/programs")
          }
        ></i>
      </div>

      <p className="custom-title-register-monthly text-center">
        1 Month Course Registration Form
      </p>

      <div
        className="custom-con-form1-monthly position-relative top-0 start-50"
        style={{
          transform: next ? "translate(-200%, 0)" : "translate(-50%, 0)",
        }}
      >
        <form onKeyDown={handleKeyDown}>
          <div className="d-flex flex-column mb-3">
            <label className="form-label">
              Have you ever joined Cutting Edge Academy before?
            </label>
            <label className="custom-radio-space">
              <input
                type="radio"
                name="joined"
                value="Yes"
                checked={joined === "Yes"}
                onChange={(e) => setJoined(e.target.value)}
              />
              &nbsp;Yes
            </label>

            <label className="custom-radio-space">
              <input
                type="radio"
                name="joined"
                value="No"
                checked={joined === "No"}
                onChange={(e) => setJoined(e.target.value)}
              />
              &nbsp;No
            </label>
          </div>
          {joined === "Yes" ? (
            <div className="custom-margin-form">
              <label className="form-label">Email</label>
              <input
                type="email"
                className="form-control custom-con-input"
                placeholder="example@gmail.com"
                value={emailVerify}
                onChange={(e) => setEmailVerify(e.target.value)}
              />
            </div>
          ) : (
            <></>
          )}
          {joined !== "" ? (
            <div
              onClick={() => handleNext(emailVerify)}
              className="btn custom-btn-next"
            >
              Next
            </div>
          ) : (
            <></>
          )}
        </form>
      </div>

      <div
        className="custom-con-form2-monthly position-absolute top-0 start-50"
        style={{
          transform: next ? "translate(-50%, 15rem)" : "translate(200%, 15rem)",
        }}
      >
        <form>
          <div className="custom-margin-form">
            <label className="form-label ">Full Name</label>
            <input
              type="text"
              className="form-control custom-con-input"
              placeholder="Full Name"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
            />
          </div>
          <div className="custom-margin-form">
            <label className="form-label">Email</label>
            <input
              type="email"
              className="form-control custom-con-input"
              placeholder="example@gmail.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          {joined === "No" && (
            <div className="custom-margin-form">
              <label className="form-label">Confirm Email</label>
              <input
                type="email"
                className="form-control custom-con-input"
                placeholder="Re-type your email"
                value={confirmEmail}
                onChange={(e) => setConfirmEmail(e.target.value)}
                onPaste={(e) => e.preventDefault()}
              />
              {confirmEmail !== "" &&
                email.trim().toLowerCase() !== confirmEmail.trim().toLowerCase() && (
                  <span style={{ color: "#dc2626", fontSize: "12px" }}>
                    Email does not match
                  </span>
                )}
            </div>
          )}
          <div className="custom-margin-form">
            <label className="form-label">Whatsapp Number</label>
            <input
              type="text"
              className="form-control custom-con-input"
              placeholder="6287xxxxxxxxx"
              value={phone}
              onChange={(e) => {
                setPhone(e.target.value.replace(/\D/g, ""));
              }}
            />
          </div>
          <div className="custom-margin-form">
            <label className="form-label">Date of Birth</label>
            <DateInput
              className="form-control custom-con-input"
              value={dob}
              onChange={(e) => setDob(e.target.value)}
            />
          </div>
          <div className="custom-margin-form">
            <label className="form-label">Address (Indonesia Address)</label>
            <textarea
              rows="2"
              className="form-control form-control-textarea"
              placeholder="Insert your address"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            ></textarea>
          </div>
          <div className="custom-margin-form">
            <label className="form-label">City</label>
            <input
              type="text"
              className="form-control custom-con-input"
              placeholder="City"
              value={city}
              onChange={(e) => setCity(e.target.value)}
            />
          </div>
          <div className="row align-items-center">
            <div className="col-6">
              <div className="custom-margin-form">
                <label className="form-label">Province</label>
                <input
                  type="text"
                  className="form-control custom-con-input"
                  placeholder="Province"
                  value={province}
                  onChange={(e) => setProvince(e.target.value)}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="custom-margin-form">
                <label className="form-label">Postal Code</label>
                <input
                  type="text"
                  className="form-control custom-con-input"
                  placeholder="Postal Code"
                  value={postal}
                  onChange={(e) => {
                    setPostal(e.target.value.replace(/\D/g, ""));
                  }}
                />
              </div>
            </div>
          </div>
          <div className="d-flex flex-column mt-4">
            <label className="form-label">Student Package</label>
            <label className="custom-radio-space">
              <input
                type="radio"
                name="sp"
                value="The House Convention Hall"
                checked={sp === "The House Convention Hall"}
                onChange={(e) => setSp(e.target.value)}
              />
              &nbsp;The House Convention Hall
            </label>

            <label className="custom-radio-space">
              <input
                type="radio"
                name="sp"
                value="Shipping"
                checked={sp === "Shipping"}
                onChange={(e) => setSp(e.target.value)}
              />
              &nbsp;Shipping (only for student outside Bandung)
            </label>
          </div>

          <div className="custom-margin-form mt-4">
            <label className="form-label ">Church</label>
            <select
              className="form-select custom-con-input"
              value={church}
              onChange={(e) => setChurch(e.target.value)}
            >
              <option defaultValue="">Select Local Church</option>
              <option value="IFGF Bandung">IFGF Bandung</option>
              <option value="Others">Others</option>
            </select>
          </div>
          {church === "IFGF Bandung" ? (
            <>
              <div className="custom-margin-form mt-4">
                <label className="form-label ">Last DJ Class</label>
                <select
                  className="form-select custom-con-input"
                  value={dj}
                  onChange={(e) => setDj(e.target.value)}
                >
                  <option defaultValue="">Select DJ Class</option>
                  <option value="Come">Come</option>
                  <option value="Grow">Grow</option>
                  <option value="Serve">Serve</option>
                  <option value="Lead">Lead</option>
                  <option value="None">None</option>
                </select>
              </div>
              <div className="custom-margin-form mt-4">
                <label className="form-label ">Role</label>
                <select
                  className="form-select custom-con-input"
                  value={role}
                  onChange={(e) => setRole(e.target.value)}
                >
                  <option defaultValue="">Select Role</option>
                  <option value="HITS/Mth Student">HITS/Mth Student</option>
                  <option value="Pastoral">Pastoral</option>
                  <option value="Staff">Staff</option>
                  <option value="Coach">Coach</option>
                  <option value="Care Group Leader (CGL)">
                    Care Group Leader (CGL)
                  </option>
                  <option value="Core Team Leader (CTL)">
                    Core Team Leader (CTL)
                  </option>
                  <option value="Attendees (IFGF BDG)">
                    Attendees (IFGF BDG)
                  </option>
                </select>
              </div>{" "}
            </>
          ) : church === "Others" ? (
            <>
              <div className="custom-margin-form">
                <label className="form-label">Local Church</label>
                <input
                  type="text"
                  className="form-control custom-con-input"
                  placeholder="Input Local Church"
                  value={otherChurch}
                  onChange={(e) => setOtherChurch(e.target.value)}
                />
              </div>
            </>
          ) : (
            <></>
          )}

          <div className="d-flex flex-column mt-5">
            <label className="form-label">Online / Onsite</label>
            <label className="custom-radio-space">
              <input
                type="radio"
                name="classType"
                value="Online"
                checked={classType === "Online"}
                onChange={(e) => setClassType(e.target.value)}
              />
              &nbsp;Online
            </label>

            <label className="custom-radio-space">
              <input
                type="radio"
                name="classType"
                value="Onsite"
                checked={classType === "Onsite"}
                onChange={(e) => setClassType(e.target.value)}
              />
              &nbsp;Onsite
            </label>
          </div>

          <div className="custom-margin-form mt-4">
            <label className="form-label ">Programs</label>
            <select
              className="form-select custom-con-input"
              value={programs}
              onChange={(e) => setPrograms("1 Month Course")}
            >
              <option defaultValue="1 Month Course" disabled>
                1 Month Course
              </option>
            </select>
          </div>

          {programs === "1 Year Program" ? (
            <>
              <div className="custom-margin-form mt-4">
                <label className="form-label ">Tshirt Size</label>
                <select
                  className="form-select custom-con-input"
                  value={tshirtSize}
                  onChange={(e) => setTshirtSize(e.target.value)}
                >
                  <option defaultValue="">Select Size</option>
                  <option value="s">
                    S (Lebar Dada = 52cm | Panjang Baju 67cm)
                  </option>
                  <option value="m">
                    M (Lebar Dada = 55cm | Panjang Baju 68cm)
                  </option>
                  <option value="l">
                    L (Lebar Dada = 58cm | Panjang Baju 72cm)
                  </option>
                  <option value="xl">
                    XL (Lebar Dada = 61cm | Panjang Baju 76cm)
                  </option>
                  <option value="xxl">
                    XXL (Lebar Dada = 63cm | Panjang Baju 80cm)
                  </option>
                </select>
              </div>
            </>
          ) : programs === "1 Month Course" ? (
            <>
              <div className="form-check">
                <label className="form-label">
                  Which class would you like to join ?
                </label>

                {classDetails.filter((c) => !["MASTERCLASS", "CONFERENCE"].includes(c.code)).map((c) => {
                  const currentIdx = classOrder.indexOf(currentClass);
                  const isPassed = currentIdx > 0 && classOrder.indexOf(c.code) < currentIdx;
                  return (
                  <div className="custom-text-checkbox" key={c.code}>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value={c.code}
                      checked={classes.className.some((cl) => cl.name === c.code)}
                      onChange={() => handleCheckboxChange(c.code)}
                    />
                    <label className="form-check-label">{c.className}</label>
                    {isPassed && (
                      <span style={{ fontSize: "12px", color: "#fb3104", marginLeft: "8px" }}>
                        Sudah lewat, akan dijadwalkan batch berikutnya
                      </span>
                    )}
                  </div>
                  );
                })}
              </div>

              {/* Pilihan cara bayar — hanya relevan kalau ambil >1 kelas BARU.
                  Kelas berstatus "completed" (sudah pernah lunas untuk student
                  returning) tidak dihitung, karena tidak ditagih lagi. */}
              {needsPaymentPlan && (
                <div className="d-flex flex-column mt-4">
                  <label className="form-label">Payment Option</label>
                  <label className="custom-radio-space">
                    <input
                      type="radio"
                      name="paymentPlan"
                      value="full"
                      checked={paymentPlan === "full"}
                      onChange={(e) => setPaymentPlan(e.target.value)}
                    />
                    &nbsp;Full Payment — pay for all {billableClassCount} classes
                    at once, in a single payment now
                  </label>
                  <label className="custom-radio-space">
                    <input
                      type="radio"
                      name="paymentPlan"
                      value="installment"
                      checked={paymentPlan === "installment"}
                      onChange={(e) => setPaymentPlan(e.target.value)}
                    />
                    &nbsp;Installment — pay per class: you pay for your first class
                    now, and each remaining class is billed when that class is
                    about to start
                  </label>
                </div>
              )}
            </>
          ) : (
            <></>
          )}

          <div className="custom-margin-form mt-4">
            <label className="form-label">
              Bagaimana kisah perjalanan kekristenan Anda, ketika Anda mengalami
              lahir baru hingga saat ini?
            </label>
            <textarea
              rows="2"
              className="form-control form-control-textarea"
              value={q1}
              onChange={(e) => setQ1(e.target.value)}
              // placeholder="Insert your answer"
            ></textarea>
          </div>
          <div className="custom-margin-form">
            <label className="form-label">
              Apakah Anda sudah mengalami baptisan?
            </label>
            <textarea
              rows="1"
              className="form-control form-control-textarea"
              value={q2}
              onChange={(e) => setQ2(e.target.value)}
              // placeholder="Insert your answer"
            ></textarea>
          </div>
          <div className="custom-margin-form">
            <label className="form-label">
              Ceritakan beberapa pengalaman pelayanan Anda dan buah dari
              pelayanan-pelayanan tersebut.
            </label>
            <textarea
              rows="2"
              className="form-control form-control-textarea"
              value={q3}
              onChange={(e) => setQ3(e.target.value)}
              // placeholder="Insert your answer"
            ></textarea>
          </div>
          <div className="custom-margin-form">
            <label className="form-label">
              Apa rencana dan langkah Anda selanjutnya setelah mengikuti Cutting
              Edge Academy?
            </label>
            <textarea
              rows="2"
              className="form-control form-control-textarea"
              value={q4}
              onChange={(e) => setQ4(e.target.value)}
              // placeholder="Insert your answer"
            ></textarea>
          </div>
          <div className="custom-margin-form">
            <label className="form-label">
              Mengapa Anda ingin bergabung dengan Cutting Edge Academy?
            </label>
            <textarea
              rows="2"
              className="form-control form-control-textarea"
              value={q5}
              onChange={(e) => setQ5(e.target.value)}
              // placeholder="Insert your answer"
            ></textarea>
          </div>

          <button
            type="submit"
            className="btn custom-btn-regis"
            onClick={(e) => handleSubmit(e, email)}
            // onClick={(e) => handleTest(e, email)}
          >
            Submit
          </button>
        </form>
      </div>
    </main>
  );
};

export default RegisterMonthly;
